import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import getLanguageFromUrl from 'utils/getLanguageFromUrl'

const selectedLanguage = getLanguageFromUrl()

if (selectedLanguage === 'en') {
  document.documentElement.dir = 'ltr'
  document.documentElement.lang = 'en'
}

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    lng: selectedLanguage,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })

export default i18n
